function testimonials(name, autoplay, interval) {
    document.querySelectorAll(name).forEach(carousel => new Splide(carousel, {
        type: 'loop',
        autoplay: autoplay,
        speed: interval,
        pauseOnHover: true
    }).mount());
}